import {AbstractControl, FormArray, FormGroup} from '@angular/forms';

export function reactiveFormValidator(control: AbstractControl) {
  if (control instanceof FormGroup) {
    Object.keys(control.controls).forEach(c => reactiveFormValidator(control.get(c)));
  } else if (control instanceof FormArray) {
    Object.keys(control.controls).forEach(c => reactiveFormValidator(control.get(c)));
  } else if (control) {
    control.markAsTouched();
    control.markAsDirty();
  }
}
